import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Box } from '../../../../third-party-components/material-ui';

const TaskNoteDialog = ({visible, onClose, children}) => (
    <div>
        {visible &&
        <Dialog title=" " closeIcon={true} onClose={onClose} className="task-dialog">
            <Box className="task-dialog-container">
                <Box className="task-dialog-header">
                    NOTE
                </Box>
                <Box className="task-dialog-body">
                    <Box>{children}</Box>
                </Box>
            </Box>
        </Dialog>}
    </div>
)

export default TaskNoteDialog;